import { Formik, Form } from 'formik';
import { Button } from '@neshane/blueberry';
import { FormikInput } from '../../../../common/forms';
import { phoneSchema } from '../../../../common/validation';

/**
 * Phone Step Component
 * First step of user login - collect phone number
 */
function PhoneStep({ onSubmit, loading = false, error = null }) {
    return (
        <Formik
            initialValues={{ phoneNumber: '' }}
            validationSchema={phoneSchema}
            onSubmit={onSubmit}
        >
            {({ isSubmitting, isValid }) => (
                <Form>
                    <FormikInput
                        name="phoneNumber"
                        type="tel"
                        label="شماره موبایل"
                        placeholder="09123456789"
                        helpText="شماره موبایل خود را وارد کنید"
                        disabled={loading || isSubmitting}
                        required
                        autoFocus tooltip="شماره موبایل - 09123456789" />

                    <Button
                        type="submit"
                        variant="primaryBrand"
                        text={loading || isSubmitting ? 'در حال ارسال...' : 'ارسال کد تایید'}
                        isLoading={loading || isSubmitting}
                        disabled={loading || isSubmitting || !isValid}
                        fit="parent"
                    />
                </Form>
            )}
        </Formik>
    );
}

export default PhoneStep;
